module.exports = __webpack_public_path__ + "static/img/b3_left.a38b67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b3_left.png
// module id = rl0m
// module chunks = 1